exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".distribution-icon{margin-left:5px;opacity:0.6;font-size:0.8em;padding-top:3px}\n", ""]);

// exports
